import SystemAvailabilityApi from "@js-app/office/api/system-availability-api";
class SystemAvailabilityService {
    getSystemAvailabilityService(data) {
        return SystemAvailabilityApi.getSystemAvailability(data);
    }
}

export default new SystemAvailabilityService();